import Hero from "./components/Hero";
import AboutSection from "./components/AboutSection";
import MovingTruck from "./components/MovingTruck";
import ServicesSection from "./components/ServicesSection";
import AreasPreviewSection from "./components/AreasPreviewSection";
import StatsSection from "./components/StatsSection";
import ValuesSection from "./components/ValuesSection";
import WhyChooseUsSection from "./components/WhyChooseUsSection";
import ProcessSection from "./components/ProcessSection";
import TestimonialsSection from "./components/TestimonialsSection";
import CtaSection from "./components/CtaSection";

export default function Home() {
  return (
    <>
      <Hero />
      <AboutSection />
      <MovingTruck />
      <ServicesSection />
      <AreasPreviewSection />
      <StatsSection />
      <ValuesSection />
      <WhyChooseUsSection />
      <ProcessSection />
      <TestimonialsSection />
      <CtaSection />
    </>
  );
}